import toast from "lib/toast";

import { DriverNotifier } from "./driverEffects";

export const toastNotifier: DriverNotifier = {
  error(message: string) {
    toast.error(message);
  },
};
